import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import Auth from './Auth';

export default class AuthRoute extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        let authcode = this.props.authcode;
        let InvalidComponent = this.props.InvalidComponent || Auth.routeInvalidComponent;
        if (!Auth.validate(authcode)) {
            this.allowAccess = false;
            return <Route {...this.props} component={InvalidComponent}></Route>;
        } else {
            this.allowAccess = true;
            return (<Route {...this.props}></Route>);
        }
    }
}